import {
  queryIncBins,
  queryIncContainers,
} from '@/services/internal/IncInv';

export default {
  namespace: 'incSelect',
  state: {
  },
  effects: {
      *queryIncBins({ payload, callback }, { call, put }) {
          const response = yield call(queryIncBins, payload);
          if (callback) callback(response);
          yield put({
              type: 'onQueryIncBins',
              payload: response.data
          });
      },

      *queryIncContainers({ payload, callback }, { call, put }) {
          const response = yield call(queryIncContainers, payload);
          if (callback) callback(response);
          yield put({
              type: 'onQueryIncContainers',
              payload: response.data
          });
      },
  },
  reducers: {
      onQueryIncBins(state, action) {
          return {
              ...state,
              bins: action.payload
          }
      },
      onQueryIncContainers(state, action) {
          return {
              ...state,
              containers: action.payload
          }
      },
  }
}
